import React from 'react';
import { Link } from "react-router-dom";
import axios from "axios";
import { Redirect } from 'react-router-dom';
import logoreg from "../abc.png";
import "../App.css";
import Path from "./config";
// import Footer from './Footer'
class Registration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            head_info: '',
            footerView: true,
            bottom_info: ''
        }
    }
    componentDidMount() {
        localStorage.setItem('bookstatus', '');
        axios.get(Path + 'suchi_instruction.php')
            .then(function (response) {
                //  console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data.business_table[0].mv_value);
                this.setState({
                    head_info: response.data.business_table[0].mv_value,
                    bottom_info: response.data.business_table[0].regi_bottom_instruction
                })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    }
    loginHere = () => {
        this.props.history.push(`./Login`);
    }
    submitClick = () => {
        this.props.history.push(`./RegistrationForm`);
    }
    render() {
        if (this.state.islogin) {
            return <Redirect to="/Otpcomfirm" />;
        }
        return (
            <>
                <div className="container-fluid" >
                    <span className="align-middle d-flex justify-content-center">
                        <img src={logoreg} alt="logo" style={{ width: "300px" }}></img>
                    </span>
                    <span className="align-middle d-flex justify-content-center">
                        <div dangerouslySetInnerHTML={{ __html: this.state.head_info }} style={{ width: "90%" }} />
                    </span>
                    <form>
                        <div className="row  justify-content-center ">
                            <div className="col-md-5 border  border-5 p-3 mb-2 bg-light text-dark">
                                <span className="d-block p-2 bg-danger text-white text-md-center text-capitalize">
                                    ज्यांचे आधी लेवा शुभमंगल पुस्तक सुचिमध्ये लॉगिन केलेले असेल त्यांनी Login Here वर क्लिक करावे पासवर्ड आठवत नसेल तर forget password वर क्लिक करावे.
                                    ज्यांची नोंदणी  नसेल त्यांनी Register Here वर क्लिक करून आपले अकाउंट बनवून विवाह नोंदणी पूर्ण करावी.
                                </span>
                                <div className="mb-3 text-center my-5">
                                    <Link to="/RegistrationForm">
                                        {/* commented to hide registration on 6-9-23 */}
                                        <button type="button" className="btn btn-lg btn-success m-2" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null}> Register Here 📂 </button>
                                    </Link>
                                    <button type="button" className="btn btn-lg btn-primary" onClick={() => this.loginHere()}> Login Here 🔼 </button>
                                </div>
                            </div>
                            <span className="align-middle d-flex justify-content-center " >
                                <div dangerouslySetInnerHTML={{ __html: this.state.bottom_info }} style={{ width: "90%" }} />
                            </span>
                        </div>
                    </form>
                </div>

                {/* <div>
                    <Footer />
                </div> */}
            </>
        )
    }
}

export default Registration

